import React, { useEffect, useRef, useState } from 'react';
import { Loader2, RefreshCw, WifiOff, X } from 'lucide-react';
import { FRIENDLY, onNetState } from '../lib/netResilience';

// One calm banner for temporary server trouble, in place of raw edge/CDN error text.
export const NetBanner = () => {
  const [st, setSt] = useState(null);
  const waiting = useRef([]);
  useEffect(() => {
    onNetState((s) => {
      if (s.kind === 'offline') { waiting.current.push(s); setSt({ kind: 'offline' }); }
      else if (s.kind === 'reconnecting') setSt((p) => (p?.kind === 'offline' ? p : { kind: 'reconnecting' }));
      else if (s.kind === 'write-failed') setSt({ kind: 'write' });
      else if (s.kind === 'ok') setSt((p) => (p?.kind === 'reconnecting' ? null : p));
    });
    return () => onNetState(null);
  }, []);
  if (!st) return null;
  const flush = (fn) => { const w = waiting.current; waiting.current = []; w.forEach((x) => x[fn]()); setSt(null); };
  if (st.kind === 'reconnecting') {
    return (
      <div className="fixed left-1/2 top-3 z-[300] -translate-x-1/2 rounded-full bg-slate-900/90 px-4 py-1.5 text-xs font-medium text-white shadow-lg backdrop-blur" data-testid="net-reconnecting">
        <Loader2 size={12} className="mr-1.5 inline animate-spin" /> Reconnecting…
      </div>
    );
  }
  const write = st.kind === 'write';
  return (
    <div className="fixed inset-x-3 bottom-[calc(env(safe-area-inset-bottom)+5.5rem)] sm:bottom-6 z-[300] mx-auto flex max-w-xl items-start gap-3 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900 shadow-lg" role="alert" data-testid="net-banner">
      <WifiOff size={18} className="mt-0.5 shrink-0 text-amber-600" />
      <div className="min-w-0 flex-1">
        <p className="font-semibold" data-testid="net-banner-text">{FRIENDLY}</p>
        {write && <p className="mt-0.5 text-xs text-amber-800">Your last change may not have gone through. Check it, then tap Save again.</p>}
      </div>
      {!write && (
        <button type="button" onClick={() => flush('retry')} className="inline-flex shrink-0 items-center gap-1.5 rounded-lg bg-amber-600 px-3 py-1.5 text-xs font-semibold text-white hover:bg-amber-700" data-testid="net-banner-retry">
          <RefreshCw size={13} /> Retry
        </button>
      )}
      <button type="button" onClick={() => (write ? setSt(null) : flush('dismiss'))} className="shrink-0 text-amber-700 hover:text-amber-900" title="Close" data-testid="net-banner-close"><X size={16} /></button>
    </div>
  );
};
